module.exports = __webpack_public_path__ + "static/leopard3-ec42ec39902584c2aeb8e257e186e184.png";